
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

import { bic } from './validator';

const VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => BicValidatorDirective),
  multi: true
};

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[bic][formControlName],[bic][formControl],[bic][ngModel]',
  providers: [ VALIDATOR ]
})
export class BicValidatorDirective implements Validator {
  validate(c: AbstractControl): {[key: string]: any} {
    return bic(c);
  }
}
